import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ResponsiveService } from '@frk/eds-components';
import { CartHandlerService } from '@literature/services/cart-handler.service';
import { LiteratureGlobalConfigService } from '@literature/services/literature-global-config.service';
import { AbstractBaseComponent } from '@shared/abstract-base/abstract-base.component';
import { TranslateService } from '@shared/translate/translate.service';
import {
  LiteratureDocument,
  LiteratureDocumentListingState,
  MailFormValues,
} from '@types';
import { Observable, Subscription } from 'rxjs';
import { LiteratureYourCartMailService } from './services/literature-your-cart-mail.service';

@Component({
  selector: 'ft-literature-your-cart-mail',
  templateUrl: './literature-your-cart-mail.component.html',
  styleUrls: ['./literature-your-cart-mail.component.scss'],
})
export class LiteratureYourCartMailComponent
  extends AbstractBaseComponent
  implements OnInit, OnDestroy {
  // for progress stepper
  steps = [
    this.translateService.instant('literature.lit-mail-stepper-step1'),
    this.translateService.instant('literature.lit-mail-stepper-step2'),
  ];
  current = 0;
  isHandheld$: Observable<boolean>;
  isMobile$: Observable<boolean>;
  cartState: LiteratureDocument[] = [];
  myCartLink: string;
  cartSubscription: Subscription;
  constructor(
    private responsiveService: ResponsiveService,
    private literatureYourCartMailService: LiteratureYourCartMailService,
    private cartHandler: CartHandlerService,
    private changeDetection: ChangeDetectorRef,
    private translateService: TranslateService,
    private literatureConfig: LiteratureGlobalConfigService
  ) {
    super();
    this.isHandheld$ = this.responsiveService.isHandheld$();
    this.isMobile$ = this.responsiveService.isMobile$();
  }

  setFormValues(formData: MailFormValues): void {
    this.literatureYourCartMailService.setMailFormValue(formData);
    this.literatureConfig.navigateToUrl(this.getLink());
  }

  getLink(): string {
    return `${this.literatureConfig?.navigationUrls?.orderConfirm}`;
  }

  ngOnInit(): void {
    this.setBreadcrumbItems();
    this.cartSubscription = this.cartHandler
      .getCartItems()
      .subscribe((state: LiteratureDocumentListingState) => {
        state.cartItems.forEach((data: LiteratureDocument) => {
          if (data.quantity !== 0) {
            this.cartState.push(data);
          }
        });
        this.changeDetection.detectChanges();
      });
    this.myCartLink = this.literatureConfig?.navigationUrls?.litOrderCheckoutUrl;
  }
  /**
   * get literature details page link
   * @param url string
   * @returns string
   */
  getLiteratureDetailLink(docId: string): string {
    return `${this.literatureConfig?.navigationUrls?.litDetailUrl}/${docId}`;
  }

  yourCartPage(): void {
    this.literatureConfig.navigateToUrl(this.myCartLink);
  }

  ngOnDestroy(): void {
    this.cartSubscription?.unsubscribe();
  }
}
